import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad, { handleAd } from '@ifeng-fe/ui_pc_ad';
import { Event } from '@ifeng-fe/ui_base';
import { randomSort } from 'ThreeTerminal_base/publicMethod';
import { getPicRecom } from '../../../../../services/api';

class PicOver extends React.PureComponent {
    static propTypes = {
        handleOverPrev: PropTypes.func,
        handleOverNext: PropTypes.func,
        picOverData: PropTypes.object,
        ad: PropTypes.object,
        isHitBlack: PropTypes.bool,
    };

    state = {
        jsSpan: false,
        data: [],
        replaceArr: [],
    };

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = async (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            console.log('insertArr', insertArr); // 要插入的数据的索引
            console.log('replaceArr', replaceArr); // 被替换的数据的索引
            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            await this.setState(
                {
                    data: infoData,
                    replaceArr,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    // 点击换一换,随机展示6条数据
    picBoxChange = () => {
        const { picRecomData } = this.state;
        // this.setState({ data });

        try {
            const data = randomSort(picRecomData, picRecomData.length > 5 ? 6 : picRecomData.length) || [];

            this.setState({ data });
        } catch (e) {
            console.error(e);
        }
    };

    async componentDidMount() {
        const { picOverData } = this.props;
        const { channel, current } = picOverData;

        // 从接口获取图集推荐数据
        const result = await getPicRecom(channel);

        this.setState({ picRecomData: result });

        // 插入软广
        try {
            const { ad } = this.props;

            // const ad = {
            //     data: {},
            //     preload: '',
            //     callback: (data, event, insert) => {
            //         // event 为传入的 event 事件对象，用于广告方绑定事件
            //         // insert 为我们自定义的广告插入方法
            //         event.on('init', () => {
            //             // data 为我们触发方法时传参值
            //             const insertArr = [];

            //             const replaceArr = [3];
            //             // 测试
            //              let box = document.createElement('div');

            //              box.innerHTML = '1111';

            //             insert(insertArr, replaceArr, dom => {
            //                 console.log('dom__', dom);
            //                 dom[3].appendChild(box);
            //             });
            //         });
            //     },
            // };

            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
        } catch (e) {
            console.error(e);
        }
        const data = randomSort(result, result.length > 5 ? 6 : result.length) || [];

        if (data) {
            this.setState(
                {
                    data,
                },
                () => {
                    this.adInit(data); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
                },
            );
        }

        // this.picBoxChange();

        window.location.hash = `#p=${current + 2}&_cpb_slide_last`;
    }

    adInit = data => {
        try {
            this.event.trigger('init', { data }); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };
    /**
     * 渲染组件
     */
    render() {
        const { jsSpan, data, replaceArr } = this.state;
        const { picOverData, handleOverPrev, handleOverNext, isHitBlack } = this.props;

        const createList = () => (
            <ul>
                {data.length > 1
                    ? data.map((item, index) => {
                          if (replaceArr[0] === index) {
                              return <li key="last_ad" ref={item.ref} />;
                          } else {
                              return (
                                  <li key={index}>
                                      <a href={item.url} target="_blank">
                                          <img src={item.img} alt={item.title} />
                                      </a>
                                      <a href={item.url} target="_blank">
                                          <p>
                                              <span style={{ display: 'none' }}>{item.publishTime}</span>
                                              {item.title}
                                          </p>
                                      </a>
                                  </li>
                              );
                          }
                      })
                    : ''}
            </ul>
        );

        return (
            <div className={styles.over}>
                <a className={styles.overprev} onClick={handleOverPrev}>
                    <span>上一页</span>
                </a>
                <a className={styles.overnext} onClick={handleOverNext}>
                    <span>下一图集</span>
                </a>
                <div className={styles.overCon}>
                    {!isHitBlack && (
                        <div className={styles.overConUl}>
                            <div className={styles.overTit}>
                                {/* <p>推荐图集</p> */}
                                <p>热门推荐</p>
                                <a className={styles.picAgian} onClick={this.picBoxChange}>
                                    换一组<span className={jsSpan ? styles.js_span : ''} />
                                </a>
                            </div>
                            <div>{createList()}</div>
                        </div>
                    )}
                    <Ad content={picOverData.asideAd2} styleName={styles.overAd} />
                </div>
                <div className="bomAd" style={{ marginTop: '40px' }} />
            </div>
        );
    }
}

export default errorBoundary(PicOver);
